<template lang="pug">
  #product-manuals
    header-for-login
    b-card.form-box.mx-auto(header-tag="header")
      b-container(fluid="fluid")
        b-col
          h4(:class="title_class")
            label 各種製品マニュアル
          b-row
            b-col
              //- desknet's NEO
              section
                .neo-header desknet's NEO
                b-list-group
                  b-list-group-item.border-0.pt-1(v-for="(item, index) in neoManuals" :key="index")
                    a.manual-link(:href="item.link", target="_blank") {{ item.text }}

              //- desknet's NEO オプション製品（開閉無し）
              section
                .neo-header AppSuite
                b-list-group
                  b-list-group-item.border-0.pt-1
                    a.manual-link(href="https://www.desknets.com/neo/help_apps/ja_JP/public/index.html", target="_blank") ・AppSuite マニュアル
                .neo-header RoomMgr
                b-list-group
                  b-list-group-item.border-0.pt-1
                    a.manual-link(href="https://www.desknets.com/sales/help_room/", target="_blank") ・RoomMgr マニュアル
                .neo-header セキュアブラウザ
                b-list-group
                  b-list-group-item.border-0.pt-1
                    a.manual-link(href="https://faq.desknets.com/neo/faq/NEO-C0087", target="_blank") ・セキュアブラウザ マニュアル
                .neo-header クライアント認証サービス
                b-list-group
                  b-list-group-item.border-0.pt-1
                    a.manual-link(href="https://faq.desknets.com/neo/faq/NEO-S0089", target="_blank") ・クライアント認証を利用開始するまでの初期設定

              //- タイムカード+CLOUZA（開閉有り）
              section(id="clouza", ref="clouza")
                .neo-header(@click="isClouzaOpen = !isClouzaOpen", style="cursor: pointer")
                  span タイムカード＋CLOUZA
                  b-icon.ml-2(:icon="isClouzaOpen ? 'chevron-up' : 'chevron-down'")

                b-collapse(:visible="isClouzaOpen")
                  b-list-group.mb-2
                    b-list-group-item.border-0.pt-1(v-for="(item, index) in clouzaManuals" :key="index")
                      a.manual-link(:href="item.link", target="_blank") {{ item.text }}

              //- クラウドメールサービス（開閉有り）
              section(id="mail_service", ref="mail_service")
                .neo-header(@click="isMailServiceOpen = !isMailServiceOpen", style="cursor: pointer")
                  span desknet'sクラウドメールサービス（WebARENA）
                  b-icon.ml-2(:icon="isMailServiceOpen ? 'chevron-up' : 'chevron-down'")

                b-collapse(:visible="isMailServiceOpen")
                  b-list-group
                    b-list-group-item.border-0.pt-1
                      a.manual-link(href="http://www.desknets.com/oncloud/mail/manual/service/guide.html", target="_blank") ・サービス仕様
                    b-list-group-item.border-0.pt-1
                      strong 管理ツール
                      b-list-group.ml-3
                        b-list-group-item.border-0
                          a.manual-link(href="http://www.desknets.com/oncloud/mail/manual/tool/site.html", target="_blank") ・サイトマネージャー
                        b-list-group-item.border-0.pt-1.pb-1
                          a.manual-link(href="http://www.desknets.com/oncloud/mail/manual/tool/mail.html", target="_blank") ・メールマネージャー
            b-col
              //- ChatLuck
              section
                .chat-header ChatLuck
                b-list-group
                  b-list-group-item.border-0.pt-1
                    a.manual-link(href="https://www.chatluck.com/help/", target="_blank") ・ChatLuck マニュアル
</template>

<script>
import HeaderForLogin from '@/components/supportSite/HeaderForLogin';
export default {
  name: 'ProductManuals',
  components: {
    HeaderForLogin,
  },
  data() {
    return {
      // タイトルのクラス
      title_class: 'font-weight-bold border-top border-bottom py-2 title-bg-color',
      // タイムカード+CLOUZAの開閉フラグ
      isClouzaOpen: false,
      // メールサービスの開閉フラグ
      isMailServiceOpen: false,
      // desknet's NEOのマニュアル
      neoManuals: [
        { text: "・desknet's NEO マニュアル", link: 'http://www.desknets.com/neo/help/index.html' },
        { text: '・かんたん操作マニュアル', link: 'https://faq.desknets.com/neo/faq/NEO-T0091' },
        { text: '・クライアントツール', link: 'https://www.desknets.com/neo/help/client-tool/ja_JP/public/index.html' },
      ],
      // タイムカード+CLOUZAのマニュアル
      clouzaManuals: [
        { text: "・desknet's NEO連携設定マニュアル", link: 'https://www.desknets.com/neo/pdf/manual_timecardp.pdf' },
        { text: '・CLOUZA導入マニュアル_v700', link: 'https://www.desknets.com/neo/pdf/clouza/clouza_installation_manual_v700.pdf' },
        { text: '・CLOUZA運用マニュアル_v800', link: 'https://www.desknets.com/neo/pdf/clouza/clouza_operation_manual_v800.pdf' },
        { text: '・Webタイムレコーダーマニュアル_v500', link: 'https://www.desknets.com/neo/pdf/clouza/clouza_timerec_web_manual_v500.pdf' },
        { text: '・スマートフォン用タイムレコーダーマニュアル_v300', link: 'https://www.desknets.com/neo/pdf/clouza/clouza_timerec_sp_manual_v300.pdf' },
        { text: '・タブレット用タイムレコーダーマニュアル_v100', link: 'https://www.desknets.com/neo/pdf/clouza/clouza_timerec_tab_manual_v100.pdf' },
        { text: '・有休設定の導入ガイド', link: 'https://www.desknets.com/neo/pdf/clouza/clouza_paid_vacation_installation_guide.pdf' },
        { text: '・desknets連携_CLOUZA有休オプションマニュアル_v100', link: 'https://www.desknets.com/neo/pdf/clouza/clouza_paid_vacation_manual_v100.pdf' },
        { text: '・desknets連携_CLOUZAワークフローオプションマニュアル_v100', link: 'https://www.desknets.com/neo/pdf/clouza/clouza_workflow_manual_v100.pdf' }
      ]
    }
  },
  mounted() {
    // タイムカード+CLOUZAのハッシュが存在する場合
    if (this.$route.hash === '#clouza') {
      // 開閉メニューを開く
      this.isClouzaOpen = true;
      // タイムカード+CLOUZAのDOM要素が存在する場合
      if (this.$refs.clouza) {
        // 指定した位置にスクロールする
        this.$refs.clouza.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // メールサービスのハッシュが存在する場合
    else if (this.$route.hash === '#mail_service') {
      // 開閉メニューを開く
      this.isMailServiceOpen = true;
      // メールサービスのDOM要素が存在する場合
      if (this.$refs.mail_service) {
        // 指定した位置にスクロールする
        this.$refs.mail_service.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style scoped lang="scss">
// 画面全体の幅
.form-box {
  max-width: 1200px;
}
// タイトルの背景色
.title-bg-color {
  background-color: #f8f9fa;
}
// NEO製品のタイトルのスタイル
.neo-header {
  font-weight: 600;
  font-size: 1rem;
  background-color: #f2ffff;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
}
// ChatLuckのタイトルのスタイル
.chat-header {
  font-weight: 600;
  font-size: 1rem;
  background-color: #f0ffe0;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
}
// リンクのスタイル
.manual-link {
  color: #0d6efd;
  text-decoration: none;
}
// リンクホバー時のスタイル
.manual-link:hover {
  text-decoration: underline;
  color: #084298;
}
</style>
